import { Bell } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@clarix/ui';

/**
 * Visual shell of clario-frontend's NotificationPopover. Renders a bell
 * trigger and an empty-state popover. Real notification list, unread
 * badge, and websocket subscription land later as the notification
 * system ports.
 */
export function NotificationBellShell() {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label="Notifications"
          className="text-muted-foreground hover:bg-accent hover:text-foreground flex h-8 w-8 shrink-0 items-center justify-center rounded-lg transition-all"
        >
          <Bell className="h-[18px] w-[18px]" strokeWidth={1.5} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" sideOffset={8} className="w-80 p-0">
        <div className="border-border flex items-center justify-between border-b px-3 py-2">
          <span className="text-lg font-medium">Notifications</span>
        </div>
        <div className="text-muted-foreground px-3 py-8 text-center text-md">
          No notifications yet.
        </div>
      </PopoverContent>
    </Popover>
  );
}
